import React, { useContext, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import { AppContext } from '../../contexts/AppContext';

export const AuthorisedOnly = ({ children }: { children: React.ReactNode }): Nullable<React.ReactNode> => {
	const appContext = useContext(AppContext);
	const user = appContext?.state?.user;

	return user ? children : null;
};

export const UnauthorisedOnly = ({ children }: { children: React.ReactNode }): Nullable<React.ReactNode> => {
	const appContext = useContext(AppContext);
	const user = appContext?.state?.user;

	return !user ? children : null;
};

export const BrowserOnlyPortal = ({
	children,
	selector,
}: {
	children: React.ReactNode;
	selector: string;
}): Nullable<React.ReactPortal> => {
	const ref = useRef<Element | DocumentFragment | null>(null);
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		ref.current = document.querySelector(selector);
		setMounted(true);
	}, [selector]);

	return mounted ? createPortal(children, ref.current as Element | DocumentFragment) : null;
};

// makes component static, as we say never update
export const StaticComponent = (Component: React.FC): React.NamedExoticComponent => React.memo(Component, () => true);
